import { Injectable } from "@angular/core";
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { TrocaIPOCDTO, DiasAtrasoDTO, ConsultasOperacaoScrDTO } from "src/app/model/consulta-ipoc.model";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";



@Injectable({
  providedIn: 'root'
})
export class ConsultaIpocService extends FgiBackEndService<TrocaIPOCDTO>{

  // @Override
  getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

    // @Override
    protected getResourceURL(): string {
      return 'front/integracoes/scr';
    }

  public getTrocaIPOC(idOperacao: number): Observable<Array<TrocaIPOCDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/troca-ipoc/operacao/${idOperacao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<TrocaIPOCDTO>>;
  }

  public getDiasAtraso(idOperacao: number): Observable<Array<DiasAtrasoDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/dias-atraso/operacao/${idOperacao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<DiasAtrasoDTO>>;
  }

  public getConsultasOperacaoSCR(idOperacao: number): Observable<Array<ConsultasOperacaoScrDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/consultas-operacao-scr/operacao/${idOperacao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<ConsultasOperacaoScrDTO>>;
  }

  public getTrocaIPOCporIPOC(idIpoc: string): Observable<Array<TrocaIPOCDTO>>{
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/troca-ipoc/operacao/ipoc/${idIpoc}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<TrocaIPOCDTO>>;
  }

  public desativarIpoc(idTrocaIpocScr: number,idOperacao: number): Observable<Array<TrocaIPOCDTO>>{
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/troca-ipoc/desativar/ipoc/${idTrocaIpocScr}/${idOperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<TrocaIPOCDTO>>;
  }

  public getTodasTrocasIPOC(idOperacao: number): Observable<Array<TrocaIPOCDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/troca-ipoc/operacao/todos/${idOperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<TrocaIPOCDTO>>;
  }

}


